<template>
  <aha-modal
    @hide="hide()"
    :title="title_UnpublishTemplate"
  >
    <span
      v-html="unpublishTemplateMessage"
    >
    </span>
    <template #action>
      <aha-button
        variant="danger"
        @click="handleUnpublish"
        has-margin-right
        :submitting="isPublishing"
      >
        {{ $i18nPresenter.t('Unpublish') }}
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import * as Sentry from '@sentry/vue'
import utils from '@/util'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    unpublish: {
      type: Function,
      default: () => {},
    },
    isPublishing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title_UnpublishTemplate() {
      return this.$i18nPresenter.t('Unpublish this template?')
    },
    unpublishTemplateMessage() {
      return this.$i18nPresenter.t('unpublishTemplateMessage', {
        name: this.presentation.name,
      })
    },
  },
  methods: {
    async handleUnpublish() {
      try {
        await this.unpublish()
        this.$emit('hide')
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    hide() {
      let category = ''
      switch (this.$route.name) {
        case 'Presentations':
          category = 'Presentation List > Kebab menu > Share Dialog'
          break
        case 'PresentationDetail':
          category = 'Presentation Editor > Share menu'
          break
        default:
          break
      }
      utils.mixpanelTracking(category, 'Cancel Unpublish', '', this.presentation.id)
      this.$emit('hide')
    },
  },
}
</script>
